module.exports = {
          srcSet: __webpack_public_path__ + "9fdffd51cc3e10479d719c8b8a340146-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "9fdffd51cc3e10479d719c8b8a340146-60.png",width: 60,height: 58}],
          src: __webpack_public_path__ + "9fdffd51cc3e10479d719c8b8a340146-60.png",
          toString:function(){return __webpack_public_path__ + "9fdffd51cc3e10479d719c8b8a340146-60.png"},
          
          width: 60,
          height: 58
        }